import { useEffect } from 'react';

export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} | Nuvama` : 'Nuvama';
    return () => {
      document.title = 'Nuvama';
    };
  }, [title]);
}
